import { useQuery } from "@tanstack/react-query";
import { getTeam, getTeamRiders, getTeams } from "@/api/teams";

export const qk = {
  teams: ["teams"],
  team: (teamId) => ["team", String(teamId || "")],
  teamRiders: (teamId, options = {}) => [
    "teamRiders",
    String(teamId || ""),
    options.season ?? "current",
    options.active ?? "all",
    options.includeGuests ?? false,
    options.officialMatchId ?? "",
  ],
};

export function useTeams(options = {}) {
  return useQuery({
    queryKey: qk.teams,
    queryFn: getTeams,
    staleTime: 15 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...options,
  });
}

export function useTeam(teamId, options = {}) {
  return useQuery({
    queryKey: qk.team(teamId),
    queryFn: () => getTeam(teamId),
    enabled: Boolean(teamId),
    staleTime: 15 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...options,
  });
}

export function useTeamRiders(teamId, options = {}) {
  const { season, active, includeGuests, officialMatchId, enabled = true, ...queryOptions } = options;
  return useQuery({
    queryKey: qk.teamRiders(teamId, { season, active, includeGuests, officialMatchId }),
    queryFn: () => getTeamRiders(teamId, { season, active, includeGuests, officialMatchId }),
    enabled: Boolean(teamId) && enabled,
    staleTime: 15 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...queryOptions,
  });
}
